// ui/presenters/selectableFundingSources.js

/**
 * Which funding sources the payer picker offers, and in what order.
 *
 * A presentation rule, not a mapping: it takes FundingSources that have already crossed the
 * storage boundary and decides what a user should be shown. It lived in the mapper for a while,
 * which was wrong — nothing here knows or cares about the stored shape.
 *
 * An inactive source stays selectable when the coverage being edited already points at it.
 * Otherwise opening an old coverage would blank its payer, and the user would save the erasure
 * without noticing.
 *
 * @param {import('../../domain/model/FundingSource.types').FundingSource[]} fundingSources
 * @param {string|null} [keepId] - the payer the coverage being edited already uses. A
 *   `fundingSourceId`, matched against the same — never a version's own document.
 * @returns {import('../../domain/model/FundingSource.types').FundingSource[]}
 */
// eslint-disable-next-line import/prefer-default-export
export function selectableFundingSources(fundingSources, keepId = null) {
  return (fundingSources ?? [])
    .filter((fundingSource) => fundingSource.isActive || fundingSource.fundingSourceId === keepId)
    .sort((a, b) => a.name.localeCompare(b.name));
} // selectableFundingSources()
